import { AppUpdate, AppUpdateDetail, AppMainUpdate, AppMainUpdateDetail } from '../../pages';
import { FileUpdateLayout, Layout } from '../../components';

export default [
	{
		/* APP基本設定 - 主要更新 */
		path: '/appMainUpdate',
		title: 'app-main-update',
		permission: 'authSystem',
		requireAuth: false,
		element: (
			<Layout>
				<FileUpdateLayout>
					<AppMainUpdate />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* APP基本設定 - 主要更新 - 編輯 */
		path: '/appMainUpdate/edit/:appGuid',
		title: 'app-main-update-edit',
		permission: 'authSystem',
		requireAuth: false,
		element: (
			<Layout>
				<FileUpdateLayout>
					<AppMainUpdateDetail />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* APP基本設定 - 主要更新 - 新增 */
		path: '/appMainUpdate/create',
		title: 'app-main-update-create',
		permission: 'authSystem',
		requireAuth: false,
		element: (
			<Layout>
				<FileUpdateLayout>
					<AppMainUpdateDetail />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* APP管理 */
		path: '/appupdate',
		title: 'app-update',
		permission: 'authApp',
		requireAuth: true,
		element: (
			<Layout>
				<FileUpdateLayout>
					<AppUpdate />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* APP管理 - 新增 */
		path: '/appupdate/create',
		title: 'app-update-create',
		permission: 'authApp',
		requireAuth: true,
		element: (
			<Layout>
				<FileUpdateLayout>
					<AppUpdateDetail />
				</FileUpdateLayout>
			</Layout>
		),
	},
	{
		/* APP管理 - 編輯 */
		path: '/appupdate/edit',
		title: 'app-update-edit',
		permission: 'authApp',
		requireAuth: true,
		element: (
			<Layout>
				<FileUpdateLayout>
					<AppUpdateDetail />
				</FileUpdateLayout>
			</Layout>
		),
	},
];
